import { render, staticRenderFns } from "./office_home.vue?vue&type=template&id=1b1d9c3a&"
import script from "./office_home.vue?vue&type=script&lang=js&"
export * from "./office_home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports